import * as Actions from "../Actions/CustomFieldsActions";
// import _ from '@lodash';

const initialState = {
    data: null,
    info: null,
    error: null,
    warning: null
};

const CustomFieldsReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.CUSTOMFIELDS_GET:
            {
                let AData = action.tipo !== "all" ? { ...state.data } : null;
                if (action.tipo !== "all") {
                    AData[action.tipo] = action.payload;
                }
                return {
                    ...state,
                    data: AData,
                };
            }
        case Actions.CUSTOMFIELDS_INFO:
            {
                return {
                    ...state,
                    info: action.payload
                };
            }
        case Actions.CUSTOMFIELDS_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload
                };
            }
        case Actions.CUSTOMFIELDS_ERROR:
            {
                return {
                    ...state,
                    error: action.payload
                };
            }
        default:
            {
                return state;
            }
    }
};

export default CustomFieldsReducer;
